// NGRX
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import { RoleActions, RoleActionTypes } from '../_actions/role.actions';
// Models
import { Role } from '../_models/role.model';
import { QueryParamsModel } from '../../_base/crud/models/query-models/query-params.model';

export interface RolesState extends EntityState<Role> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: any;
  lastCreatedRoleId: number;
  lastQuery: QueryParamsModel;
  error: any | null;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;

  isAllRolesLoaded: boolean;
  queryRowsCount: number;
  queryResult: Role[];
  allRoles: Role[];
}

export const adapter: EntityAdapter<Role> = createEntityAdapter<Role>();

export const initialRolesState: RolesState = adapter.getInitialState({
  isAllRolesLoaded: false,
  queryRowsCount: 0,
  queryResult: [],
  lastCreatedRoleId: undefined,
  totalCount: 0,
  listLoading: false,
  actionsloading: false,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  allRoles: [],
  error: null,
  latestSuccessfullAction: null,
});

export function rolesReducer(state = initialRolesState, action: RoleActions): RolesState {
  switch (action.type) {
    case RoleActionTypes.RolesPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedRoleId: undefined,
      };
    case RoleActionTypes.RolesActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case RoleActionTypes.RoleOnServerCreated:
      return {
        ...state,
      };
    case RoleActionTypes.RoleOnServerUpdated:
      return {
        ...state,
      };
    case RoleActionTypes.RoleOnServerDeleted:
      return {
        ...state,
      };
    case RoleActionTypes.RolesOnServerDeleted:
      return {
        ...state,
      };
    case RoleActionTypes.RoleCreated:
      return adapter.addOne(action.payload.role, {
        ...state,
        lastCreatedRoleId: action.payload.role.id,
      });
    case RoleActionTypes.RoleUpdated:
      return adapter.updateOne(action.payload.partialrole, state);
    case RoleActionTypes.RoleDeleted:
      return adapter.removeOne(action.payload.id, state);
    case RoleActionTypes.RolesDeleted:
      return adapter.removeMany(action.payload.ids, state);
    case RoleActionTypes.AllRolesLoaded:
      return {
        ...state,
        allRoles: action.payload.roles,
      };
    case RoleActionTypes.RolesPageCancelled:
      return {
        ...state,
        listLoading: false,
        showInitWaitingMessage: false,
        queryRowsCount: 0,
        queryResult: [],
        lastQuery: new QueryParamsModel({}),
      };
    case RoleActionTypes.RolesPageLoaded:
      return adapter.addMany(action.payload.roles, {
        ...initialRolesState,
        listLoading: false,
        queryRowsCount: action.payload.totalCount,
        totalCount: action.payload.totalCount,
        allRoles: state.allRoles,
        queryResult: action.payload.roles,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    case RoleActionTypes.ThrowRoleError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case RoleActionTypes.FireRoleSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
